module.exports = __webpack_public_path__ + "img/rise-3@3x.e0821d71.png";